import { render, staticRenderFns } from "./SoundSetupRubetek.vue?vue&type=template&id=63746ecb&scoped=true"
import script from "./SoundSetupRubetek.vue?vue&type=script&lang=js"
export * from "./SoundSetupRubetek.vue?vue&type=script&lang=js"
import style0 from "./SoundSetupRubetek.vue?vue&type=style&index=0&id=63746ecb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63746ecb",
  null
  
)

export default component.exports